import * as React from 'react';
import {react2angular} from "react2angular";
import confirm from './confirm';
import $ from 'jquery';
import datafangstHelpers from '../../../utilities';
import * as angular from 'angular';
import {DisplayFeature, DisplayFeatureType} from '../contract-features-3/domain';
import {ValidationIssue} from "../../../integration/representation/validation-issue";
import {Dispatcher} from "../contract-status/contract-status-modal-controllers";
import contractService from "../../../service/contract/contract-services";

interface LockButtonProps {
    featureType: any,
    clickable: any,
    featureList: any,
    dispatcher: Dispatcher
}

interface LockButtonState {
    featureType: any
}

class LockButton extends React.Component<LockButtonProps, LockButtonState> {
    constructor(props: LockButtonProps) {
        super(props);
        this.state = {featureType: props.featureType};
    }

    render() {
        const locked = this.props.featureType.locked;
        const clickable = this.props.clickable;
        const clz = 'lock fa ' + (locked ? 'fa-lock' : 'fa-unlock') + (clickable ? ' clickable' : '');

        return <span key="lockbuttonicon" className={clz}/>;
    }
}

interface FeatureIssueBubbleProps {
    issue: ValidationIssue,
    featureName: string,
    featureId: number,
    featureTypeId: number
}

class FeatureIssueBubble extends React.Component<FeatureIssueBubbleProps, {}> {
    render() {
        let severity = 'Feil';
        if (this.props.issue.severity == 'NOTABENE') severity = 'Notabene';
        if (this.props.issue.severity == 'WARNING') severity = 'Advarsel';
        const title = severity + ' ved validering av ' + this.props.featureName + ':';
        const classString = 'issuepopover clickable issuebubble ' + this.props.issue.severity.toLowerCase();

        return <span className={classString}
                     data-content={this.props.issue.message}
                     data-title={title}
                     data-issueid={this.props.issue.id}
                     data-severity={severity}
                     data-featureid={this.props.featureId}
                     data-featuretypeid={this.props.featureTypeId}>!</span>;
    }
}

interface FeatureTypeCommentsProps {
    comments: any,
    typeId: any,
    destination: any,
    dispatcher: Dispatcher
}

class FeatureTypeComments extends React.Component<FeatureTypeCommentsProps, {}> {
    render() {
        const comments = this.props.comments;
        const populated = (comments && comments.length) ? ' populated' : '';
        const className = 'clickable glyphicon glyphicon-comment featuretypecomment' + populated;

        const typeId = this.props.typeId;
        const destination = this.props.destination;
        const dispatcher = this.props.dispatcher;
        const onClick = function () {
            dispatcher.featureTypeCommentClicked(typeId, destination);
        };
        return (<span className={className}
                      onClick={onClick}
                      data-type="featuretypecomment"
                      data-destination={this.props.destination}
                      data-typeid={this.props.typeId}/>);
    }
}

interface FeatureCommentProps {
    comments: any,
    type: any,
    feature: any,
    destination: any,
    dispatcher: Dispatcher
}

class FeatureComment extends React.Component<FeatureCommentProps, {}> {

    render() {

        const comments = this.props.comments;
        const populated = comments && comments.length > 0 ? ' populated' : '';
        const className = 'glyphicon glyphicon-comment featurecomment action-btn' + populated;

        const type = this.props.type;
        const feature = this.props.feature;
        const destination = this.props.destination;
        const dispatcher = this.props.dispatcher;

        const onClick = function () {
            dispatcher.featureCommentClicked(type, feature, destination);
        };
        return (<span className={className}
                      onClick={onClick}
                      data-type="featurecomment"
                      data-destination={this.props.destination}
                      data-typeid={this.props.type.id}
                      data-featureid={this.props.feature.id}/>);
    }
}

interface LockFeatureProps {
    feature: DisplayFeature,
    featureTypeId: number,
    featureRow: any,
    dispatcher: Dispatcher,
    typeLock: any
}

interface LockFeatureState {
    locked: boolean
}

class LockFeature extends React.Component<LockFeatureProps, LockFeatureState> {
    constructor(props: LockFeatureProps) {
        super(props);
        this.state = {locked: this.props.feature.isLocked};
    }

    render() {
        const featureLocked = this.state.locked;
        const clickable = ((window as any) as any).datastore.canLockFeature;

        const clz = 'lock fa action-btn ' + (featureLocked ? 'fa-lock' : 'fa-unlock') + (clickable ? ' clickable' : '');

        if (clickable) {
            return (
                <span key="lockbuttonicon" className={clz}/>
            );
        } else {
            return <span key="lockbuttonicon" className={clz}/>;
        }
    }

}

interface DeleteFeatureProps {
    feature: DisplayFeature,
    featureType: DisplayFeatureType,
    features: any,
    dispatcher: any
}

class DeleteFeature extends React.Component<DeleteFeatureProps, {}> {
    render() {
        const featureTypeLocked = this.props.featureType.isLocked;
        const featureLocked = this.props.feature.isLocked;
        const locked = featureTypeLocked || featureLocked;
        const className = 'glyphicon glyphicon-trash action-btn ' + (locked ? 'disabled' : '');
        const tooltip = 'Objektet er låst';
        if (locked) {
            return (
                <span className={className} title={tooltip}/>
            );
        } else {
            return (
                <span className={className} onClick={() => this.handleClick()}/>
            );
        }
    }

    handleClick() {
        const featureId = this.props.feature.id;
        const featureTypeId = this.props.feature.typeId;
        const features = this.props.features;
        const dispatcher = this.props.dispatcher;

        confirm('Er du sikker?', {
            description: 'Vennligst bekreft at du ønsker å slette dette objektet',
            confirmLabel: 'OK',
            abortLabel: 'Avbryt'
        }).then(function () {
            dispatcher.deleteFeature(featureId, featureTypeId).then(function () {
                for (let i = 0; i < features.length; i++) {
                    if (features[i].id == featureId) {
                        features.splice(i, 1);
                        break;
                    }
                }
                if (features.length == 0) {
                    dispatcher.featureTypeSelection.toggleSelected(featureTypeId, true);
                    ((window as any) as any).datastore.featureTypes = (window as any).datastore
                        .featureTypes.filter((featureType: any) => featureType.id != featureTypeId);
                }
                dispatcher.signalSelectonHasChanged();
            });
        });
    }
}

interface FeatureRowProps {
    feature: any,
    locked: boolean,
    featureType: any,
    displayAttributes: any,
    dispatcher: any,
    showQualityParams: any,
    typeLock: any
}

interface FeatureRowState {
    locked: any
}

class FeatureRow extends React.Component<FeatureRowProps, FeatureRowState> {
    constructor(props: FeatureRowProps) {
        super(props);
        const isLocked = this.props.feature.isLocked || this.props.locked;
        this.state = {locked: isLocked};
    }

    setLockedState(isLocked: any) {
        this.setState({locked: isLocked});
    }

    render() {
        const feature = this.props.feature;
        const featureType = this.props.featureType;
        const isLocked = this.state.locked || featureType.locked;
        // Issues
        const errors = feature.errors.concat(feature.warnings).concat(feature.notabenes)
            .filter((i: any) => !i.resolved)
            .map((issue: any) => <FeatureIssueBubble key={issue.id || issue.message} issue={issue} featureName={feature.name}
                                              featureId={feature.id} featureTypeId={featureType.id}/>);

        const displayAttributes = this.props.displayAttributes;
        let attributes = Object.keys(displayAttributes)
            .map(key => displayAttributes[key])
            .sort((attr1, attr2) => attr1.importance - attr2.importance)
            .map(function (displayAttribute) {
                const att = feature.attributes[displayAttribute.id];
                let val = att === undefined ? '' : att.value;

                if (displayAttribute.id === "operation") {
                    val = datafangstHelpers.operationFromDomain(feature.operation);
                }

                let attId = 'new';
                if (att) attId = att.id;

                const enumArray = Object.keys(displayAttribute.enumerations).map(function (key) {
                    const enu = displayAttribute.enumerations[key];
                    return {value: enu, text: enu};
                });
                enumArray.push({value: '', text: '(ingen verdi)'});
                const enums = JSON.stringify(enumArray);

                let type = 'text';
                switch (displayAttribute.valueType) {
                    case 'NUMBER':
                        type = 'text';
                        break;
                    case 'ENUM':
                        type = 'select';
                        break;
                    default:
                        type = 'text';
                        break;
                }
                let displayValue = val;
                if (displayValue !== '' && displayAttribute.unit) {
                    displayValue += ' ' + displayAttribute.unit;
                }


                let align = 'align-left';
                if (displayAttribute.unit) align = 'align-right';

                let className = align;
                if (!isLocked) {
                    className += ' xxeditable';
                }

                const fillColumnTitle = 'Gir egenskapstypen samme verdi (' + val + ') for valgte vegobjekter av type ' +
                    featureType.name + ' (' + featureType.id + '). Dersom ingen vegobjekter er valgt får alle av denne typen samme verdi';

                let issueClass = '';
                if (feature.notabenes.filter((i: any) => i.location.attributeTypeId == displayAttribute.id).length > 0) issueClass = 'issues notabene';
                if (feature.warnings.filter((i: any) => i.location.attributeTypeId == displayAttribute.id).length > 0) issueClass = 'issues warning';
                if (feature.errors.filter((i: any) => i.location.attributeTypeId == displayAttribute.id).length > 0) issueClass = 'issues error';

                let fillTag = <span key="fill"/>;
                if (!featureType.locked) {
                    fillTag =
                        <span key="fill" className="fill-column glyphicon glyphicon-resize-vertical pull-left clickable"
                              title={fillColumnTitle}>
                                   </span>;
                }

                return (
                    <td key={displayAttribute.id} className={issueClass}>

                        {fillTag}

                        <a key="name" className={className}
                           data-type={type}
                           data-mode="inline"
                           data-featuretypeid={featureType.id}
                           data-featureid={feature.id}
                           data-test="test"
                           data-attributeid={attId}
                           data-displaykey={displayAttribute.id}
                           data-numdecimals={displayAttribute.numDecimals}
                           data-valuetype={displayAttribute.valueType}
                           data-fieldlength={displayAttribute.fieldLength}
                           data-source={enums}
                           data-value={val}>
                            {displayValue}
                        </a>
                    </td>
                );
            }, this);

        const selectedClass = feature.isSelected ? 'selected' : '';
        const lastModifiedText = 'Sist endret ' + datafangstHelpers.formatDate(new Date(feature.lastModified));

        const deleteIcon = (window as any).datastore.canDeleteFeature ? <DeleteFeature key="deletefeature"
                                                                                       dispatcher={this.props.dispatcher}
                                                                                       feature={feature}
                                                                                       featureType={this.props.featureType}
                                                                                       features={this.props.featureType.features}/> :
            <span key="deletefeature"></span>;

        const lockFeature = <LockFeature key="lockfeature"
                                         featureRow={this}
                                         dispatcher={this.props.dispatcher}
                                         featureTypeId={this.props.featureType.id}
                                         typeLock={this.props.typeLock}
                                         feature={feature}/>;
        if (this.props.showQualityParams) {
            const method = <td key="method" className="qualityparam">{feature.measurementMethod}</td>;
            const accuracy = <td key="q2" className="qualityparam">{feature.measurementAccuracy}</td>;
            attributes = [method, accuracy].concat(attributes);
        }

        return <tr key={feature.id} className={selectedClass}>

            <td key="comment" className="clickable">
                {lockFeature}
                <FeatureComment key="fcomment"
                                dispatcher={this.props.dispatcher}
                                comments={feature.comments}
                                destination={feature.destination}
                                type={this.props.featureType}
                                feature={feature}/>
                {deleteIcon}
                <span title={lastModifiedText} key="name"
                      onClick={() => this.handleClick()}>{feature.name}</span> {errors} </td>
            {attributes}
        </tr>;
    }

    handleClick() {
        $('#feature-data').find('.cssloader').removeClass('hidden');
        this.props.feature.isSelected = !this.props.feature.isSelected;
        this.props.dispatcher.toggleFeature(this.props.feature.id);
        this.props.dispatcher.signalSelectonHasChanged();
    }
}

interface FeatureListProps {
    featureType: any,
    showLockIcon: any,
    showQualityParams: any,
    dispatcher: any
}

class FeaturesList extends React.Component<FeatureListProps, {}> {
    constructor(props: FeatureListProps) {
        super(props);
        const isLocked = this.props.featureType.locked;

        this.state = {
            locked: isLocked
        }
    }

    setLockedState(isLocked: any) {
        this.setState({locked: isLocked});
    }

    render() {
        const featureList = this;
        const isLocked = this.props.featureType.locked;
        const featureType = this.props.featureType;

        const displayAttributes = featureType.displayAttributes;
        displayAttributes.operation = {
            name: "Operasjon",
            popTitle: "Operasjon",
            popDescription: "Angir hva slags operasjon som skal benyttes når vegobjektet lagres i NVDB",
            key: "operasjon",
            id: "operation",
            importance: 20002,
            enumerations: {noop: "noop"}
        };


        let attributeNames = Object.keys(displayAttributes)
            .map(function (key) {
                return displayAttributes[key];
            })
            .sort(function (attr1, attr2) {
                return attr1.importance - attr2.importance;
            })
            .map(function (displayAttribute) {
                const reqClass = 'glyphicon glyphicon-asterisk requirement-level ' + displayAttribute.requirement;
                let sortType = 'string';
                if (displayAttribute.valueType == 'NUMBER') {
                    sortType = 'float';
                }
                let popover = displayAttribute.popDescription;
                if (displayAttribute.requirementComment) {
                    popover += '<br>' + displayAttribute.requirementComment;
                }
                return (
                    <th key={displayAttribute.id} data-sort={sortType}>
                        <span className="pophelp"
                              data-content={popover}
                              title={displayAttribute.popTitle}>

                            {displayAttribute.name}

                            <span key="2"
                                  className={reqClass}/>
                        </span>
                    </th>
                );
            }, this);
        const dakatUrl = 'http://labs.vegdata.no/nvdb-datakatalog/' + featureType.id;
        const key = 'featurestable' + featureType.id;

        const canLock = ((window as any) as any).datastore.canLockFeatureType;

        const lockButton = this.props.showLockIcon ?
            <LockButton key="lock" featureType={featureType} clickable={canLock} dispatcher={this.props.dispatcher}
                        featureList={featureList}/>
            : <span key="lock"></span>;

        const featureRows = featureType.features.map(function (feature: any) {
            const locked = isLocked || feature.locked;
            return (
                <FeatureRow key={feature.id} locked={locked} feature={feature}
                            displayAttributes={featureType.displayAttributes}
                            featureType={featureType} dispatcher={this.props.dispatcher}
                            showQualityParams={this.props.showQualityParams} typeLock={lockButton}/>
            );
        }, this);

        if (this.props.showQualityParams) {
            const method = <th key="h2" className="qualityparam" data-sort="string">Målemetode</th>;
            const accuracy = <th key="h3" className="qualityparam" data-sort="string">Nøyaktighet</th>;
            attributeNames = [method, accuracy].concat(attributeNames);
        }

        return (
            <div className="features" key={key}>
                <h3 key="title">
                    {featureType.name}
                    <FeatureTypeComments key={key + 'ftcomment'} destination={featureType.destination}
                                         comments={featureType.comments} typeId={featureType.id}
                                         dispatcher={this.props.dispatcher}/>
                    {lockButton}
                    <a key={key + 'dakaturl'} className="dakaturl" target="_datacatalogen" href={dakatUrl}>i
                        datakatalogen</a>
                </h3>
                <table key={key + 'table'}>
                    <thead key="head">
                    <tr key="frow">
                        <th key="h1" data-sort="featurename">Vegobjekt</th>
                        {attributeNames}
                    </tr>
                    </thead>
                    <tbody key="tbody">
                    {featureRows}
                    </tbody>
                </table>
            </div>
        );

    }
}


const getSelectedFeatureTypes = function () {
    return {
        featureTypes: (window as any).datastore.featureTypes.filter((f: any) => f.isSelected)
    };
};

interface reactFeaturesEditorProps {
    contractid: string,
    dispatcher: any
}

interface reactFeaturesEditorState {
    showQualityParams: any,
    featureTypes: any
}

class reactFeaturesEditor extends React.Component<reactFeaturesEditorProps, reactFeaturesEditorState> {

    constructor(props: reactFeaturesEditorProps) {
        super(props);
        this.state = Object.assign({showQualityParams: false}, getSelectedFeatureTypes());
    }

    handleSelectionChange() {
        this.setState(getSelectedFeatureTypes());
    }

    setShowQualityParams(toggle: any) {
        this.setState({showQualityParams: toggle})
    }

    componentDidMount() {
        const dispatcher = this.props.dispatcher;
        dispatcher.addListener(dispatcher.reactFeaturesEditorKey, () => this.handleSelectionChange());
    }

    render() {
        const featureTypes = this.state.featureTypes
            .map(function (featureType: any) {
                const showLock = false;
                return <FeaturesList key={'featureType' + featureType.id} featureType={featureType}
                                     showLockIcon={showLock}
                                     dispatcher={this.props.dispatcher}
                                     showQualityParams={this.state.showQualityParams}/>;
            }, this);

        if (featureTypes.length === 0) {

            return (
                <div key="reactFeaturesEditor">
                    <div key="spinner" className="cssloader"/>
                </div>
            );

        } else {

            return (
                <div key="reactFeaturesEditor">
                    <div className="checkbox float-right" key="qualityparamToggleContainer">
                        <label key="qualityparamToggle">
                            <input type="checkbox"
                                   onChange={(event) => this.setShowQualityParams(event.target.checked)}
                                   key="qualityparamToggleInput"/> Vis kvalitetsparametre
                        </label>
                    </div>
                    <h1 key="h1">Vegobjekter
                        <div key="spinner" className="cssloader inline-loader hidden"></div>
                    </h1>
                    <div key="featuretypes">{featureTypes}</div>
                </div>

            );
        }
    }
}

export default angular.module('dataforvalter.contract-features-table-react', [])
    .component('reactFeaturesEditorOld', react2angular(reactFeaturesEditor, ['contractid', 'dispatcher'], []))
    .name;
